import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Cellgroup = () => {
    const navigate = useNavigate();
    const [cellgroup, setCellgroup] = useState({
        id: "",
        name: "",
        request: "",
        admin: "",
        pendingJoinState: "",
        adminphone: "",
        description: "",
        whatsapp: "",
        leaders: [],
        joined: false,
        dateJoined: null,
    });

    const memberId = localStorage.getItem("UserID");
    const obj = localStorage.getItem("SelectedGroup");
    const rec = JSON.parse(obj);
    const smallGroupID = rec.id;

    const findFormData = async () => {
        try {
            const slctdObj = await localStorage.getItem("SelectedGroup");
            const ministryObj = JSON.parse(slctdObj);

            if (ministryObj) {
                setCellgroup({
                    id: ministryObj.id,
                    name: ministryObj.name,
                    description: ministryObj.description,
                    whatsapp: ministryObj.whatsapp,
                    admin: ministryObj.admin,
                    request: ministryObj.request,
                    pendingJoinState: ministryObj.pendingJoinState,
                    adminphone: ministryObj.adminphone,
                    joined: ministryObj.joined,
                });

                console.log("Cell data found");
            } else {
                console.log("No cell data found");
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {

        findFormData();
    }, []);

    const handleJoin = async () => {
        try {
            let joinResponse = await fetch(`${API_URL}/membersmallgrp/joincell`, {
                method: "post",
                body: JSON.stringify({
                    MemberID: memberId,
                    SmallGroupID: smallGroupID,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            let approveResJson = await joinResponse.json();
            console.log(approveResJson);
            Swal.fire({ text: "Request to submitted!" });
            navigate(`/home`);
            // findFormData();
        } catch {
            Swal.fire({ text: "Error sending request, check your network connection", icon: "error" });
        }
    };

    const handleLeave = async () => {
        try {
            let joinResponse = await fetch(
                `${API_URL}/membersmallgrp/reqleave/${memberId}/${smallGroupID}`,
                {
                    method: "put",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            let approveResJson = await joinResponse.json();
            console.log(approveResJson);
            Swal.fire({ text: "Request to leave sent!", icon: "success" });
            navigate(`/home`);
        } catch {
            Swal.fire({ text: "Error sending request, check your network connection", icon: "error" });
        }
    };

    return (
        <div style={{ padding: '18px', marginBottom: '60px', backgroundColor: '#fff', minHeight: '100vh' }}>
            {/* Header with Back Button */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginBottom: '15px',
                position: 'relative'
            }}>
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        marginRight: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease',
                        ':hover': {
                            backgroundColor: '#f0f2f5'
                        }
                    }}
                >
                    <ArrowBackIcon style={{ color: '#1a6363', fontSize: '28px' }} />
                </button>
                <h4 style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: '19px',
                    color: '#1a6363',
                    fontWeight: '600',
                    margin: 0,
                    paddingRight: '52px'
                }}>
                    Home Group Details
                </h4>
            </div>

            {/* Cell Group Content */}
            <div style={{
                border: '1px solid #1a6363',
                borderRadius: '10px',
                padding: '15px',
                margin: '10px auto',
                maxWidth: '500px',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}>
                <h5 style={{ margin: '0', fontSize: '16px', color: '#ffffff', backgroundColor: '#1a6363', padding: '10px', borderRadius: '5px' }}>
                    {cellgroup.name}
                </h5>
                <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
                    {cellgroup.description}
                </p>

                {/* <p style={{
                    margin: 0,
                    fontSize: "16px",
                    marginBottom: "16px",
                    color: "#1a6363",
                    fontWeight: 500,
                    textDecoration: "underline"
                }}>
                    Leader(s):
                </p> */}

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    borderBottomWidth: 1,
                    borderBottomColor: "#1a6363",
                    marginBottom: "16px",
                }}>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <span style={{
                            fontFamily: "Arial, sans-serif",
                            fontSize: "16px",
                            color: "#1a6363",
                            fontWeight: 500
                        }}>
                            {/* {cellgroup.admin} */}
                            WhatsApp Link:
                        </span>
                    </div>

                    <span style={{
                        fontFamily: "Arial, sans-serif",
                        fontSize: "14px",
                        color: "#555",
                        marginTop: "4px"
                    }}>
                        {/* Tel: {cellgroup.adminphone} */}
                        <a href={cellgroup.whatsapp} style={{ color: "#555" }}>
                            {/* {cellgroup.whatsapp} */}
                            Click here to join WhatsApp Group
                        </a>
                    </span>
                </div>

                {cellgroup.joined ? (
                    <>
                        <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
                            Date Joined: {cellgroup.dateJoined}
                        </p>
                        <button onClick={handleLeave} style={{
                            backgroundColor: '#ff4d4d',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '10px 20px',
                            cursor: 'pointer',
                            width: '100%',
                            marginTop: '15px'
                        }}>
                            Request to Leave
                        </button>
                    </>
                ) : cellgroup.pendingJoinState ? (
                    <button style={{
                        backgroundColor: '#1a6363',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: '15px'
                    }}>
                        Request to Join pending
                    </button>
                ) : (
                    <button onClick={handleJoin} style={{
                        backgroundColor: '#1a6363',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: '15px'
                    }}>
                        Request to Join
                    </button>
                )}
            </div>
        </div>
    );
};

export default Cellgroup;